import zod from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

export const SipClientReasonFormSchema = zod.object({
  id: zod.number().optional(),
  description: zod.string({ required_error: MANDATORY_FIELD }),
});
